export default "__VITE_ASSET__CDO8U8Bw__"